<script lang="ts" setup>
import MainHeader from "@/components/main/MainHeader.vue";
import MainFooter from "@/components/main/MainFooter.vue";
import CartErrorModal from "@/components/common/cart/CartErrorModal.vue";
import { store } from "~/store";
import { HomeService } from "~/services/HomeService";
import useHomeStore from "~/stores/home";
import eventBus from "~/event-bus";
import { onBeforeUnmount, ref } from "vue";

defineOptions({
  name: "DefaultLayout",
});

const route = useRoute();
const withoutFooter = route.meta.withoutFooter;
const theme = ref(store.getters.getTheme);
const homeStore = useHomeStore();

const cartErrorOpen = ref(false);
const cartErrorMessages = ref<Array<{ detail?: string; title?: string }>>([]);
const cartErrorTitle = ref<string | undefined>(undefined);

function onCartError(payload: {
  errors?: Array<{ detail?: string; title?: string }>;
  title?: string;
}) {
  cartErrorMessages.value = payload?.errors ?? [];
  cartErrorTitle.value = payload?.title;
  cartErrorOpen.value = true;
}

eventBus.on("cart-error", onCartError);
onBeforeUnmount(() => eventBus.off("cart-error", onCartError));

if (import.meta.server) {
  const hasCategories = Array.isArray(homeStore.categories)
    ? homeStore.categories.length > 0
    : false;

  if (!hasCategories) {
    try {
      const homeService = new HomeService();
      await homeService.getCategories();

      const deserializedCategories =
        store.getters["catalogs/getDeserealizeCategories"];
      homeStore.$patch({
        categories: Array.isArray(deserializedCategories)
          ? deserializedCategories
          : [],
        rawCategories: store.getters["catalogs/getCategories"],
      });
    } catch {
      // Do not block SSR when categories API is unavailable.
      homeStore.$patch({
        categories: [],
      });
    }
  }
}
</script>

<template>
  <div
    class="min-h-screen d-flex flex-column justify-content-between container-3xl mx-auto"
    :data-bs-theme="theme"
  >
    <main-header />

    <main class="mb-3 px-0 px-lg-5 flex-grow-1 min-menu container-fluid">
      <!-- <wishlist-nav v-if="isMobileSize" /> -->
      <slot></slot>
    </main>

    <main-footer v-if="!withoutFooter" />

    <cart-error-modal
      v-model="cartErrorOpen"
      :errors="cartErrorMessages"
      :title="cartErrorTitle"
    />
  </div>
</template>

<style lang="scss">
@media (max-width: 991.98px) {
  .min-menu {
    padding-bottom: calc(88px + env(safe-area-inset-bottom));
  }
}
</style>
